!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.et = t());
}(this, function () {
  "use strict";

  return [{
    locale: "et",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var a = !String(e).split(".")[1];
      return t ? "other" : 1 == e && a ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "aasta",
        relative: {
          0: "käesolev aasta",
          1: "järgmine aasta",
          "-1": "eelmine aasta"
        },
        relativeTime: {
          future: {
            one: "{0} aasta pärast",
            other: "{0} aasta pärast"
          },
          past: {
            one: "{0} aasta eest",
            other: "{0} aasta eest"
          }
        }
      },
      "year-short": {
        displayName: "a",
        relative: {
          0: "käesolev aasta",
          1: "järgmine aasta",
          "-1": "eelmine aasta"
        },
        relativeTime: {
          future: {
            one: "{0} a pärast",
            other: "{0} a pärast"
          },
          past: {
            one: "{0} a eest",
            other: "{0} a eest"
          }
        }
      },
      month: {
        displayName: "kuu",
        relative: {
          0: "käesolev kuu",
          1: "järgmine kuu",
          "-1": "eelmine kuu"
        },
        relativeTime: {
          future: {
            one: "{0} kuu pärast",
            other: "{0} kuu pärast"
          },
          past: {
            one: "{0} kuu eest",
            other: "{0} kuu eest"
          }
        }
      },
      "month-short": {
        displayName: "k",
        relative: {
          0: "käesolev kuu",
          1: "järgmine kuu",
          "-1": "eelmine kuu"
        },
        relativeTime: {
          future: {
            one: "{0} kuu pärast",
            other: "{0} kuu pärast"
          },
          past: {
            one: "{0} kuu eest",
            other: "{0} kuu eest"
          }
        }
      },
      day: {
        displayName: "päev",
        relative: {
          0: "täna",
          1: "homme",
          2: "ülehomme",
          "-2": "üleeile",
          "-1": "eile"
        },
        relativeTime: {
          future: {
            one: "{0} päeva pärast",
            other: "{0} päeva pärast"
          },
          past: {
            one: "{0} päeva eest",
            other: "{0} päeva eest"
          }
        }
      },
      "day-short": {
        displayName: "p",
        relative: {
          0: "täna",
          1: "homme",
          2: "ülehomme",
          "-2": "üleeile",
          "-1": "eile"
        },
        relativeTime: {
          future: {
            one: "{0} p pärast",
            other: "{0} p pärast"
          },
          past: {
            one: "{0} p eest",
            other: "{0} p eest"
          }
        }
      },
      hour: {
        displayName: "tund",
        relative: {
          0: "praegusel tunnil"
        },
        relativeTime: {
          future: {
            one: "{0} tunni pärast",
            other: "{0} tunni pärast"
          },
          past: {
            one: "{0} tunni eest",
            other: "{0} tunni eest"
          }
        }
      },
      "hour-short": {
        displayName: "t",
        relative: {
          0: "praegusel tunnil"
        },
        relativeTime: {
          future: {
            one: "{0} t pärast",
            other: "{0} t pärast"
          },
          past: {
            one: "{0} t eest",
            other: "{0} t eest"
          }
        }
      },
      minute: {
        displayName: "minut",
        relative: {
          0: "praegusel minutil"
        },
        relativeTime: {
          future: {
            one: "{0} minuti pärast",
            other: "{0} minuti pärast"
          },
          past: {
            one: "{0} minuti eest",
            other: "{0} minuti eest"
          }
        }
      },
      "minute-short": {
        displayName: "min",
        relative: {
          0: "praegusel minutil"
        },
        relativeTime: {
          future: {
            one: "{0} min pärast",
            other: "{0} min pärast"
          },
          past: {
            one: "{0} min eest",
            other: "{0} min eest"
          }
        }
      },
      second: {
        displayName: "sekund",
        relative: {
          0: "nüüd"
        },
        relativeTime: {
          future: {
            one: "{0} sekundi pärast",
            other: "{0} sekundi pärast"
          },
          past: {
            one: "{0} sekundi eest",
            other: "{0} sekundi eest"
          }
        }
      },
      "second-short": {
        displayName: "sek",
        relative: {
          0: "nüüd"
        },
        relativeTime: {
          future: {
            one: "{0} sek pärast",
            other: "{0} sek pärast"
          },
          past: {
            one: "{0} sek eest",
            other: "{0} sek eest"
          }
        }
      }
    }
  }];
});